import { render } from "./popup-block.vue?vue&type=template&id=6f8e0d8b&scoped=true"
import script from "./popup-block.vue?vue&type=script&lang=js"
export * from "./popup-block.vue?vue&type=script&lang=js"

import "./popup-block.vue?vue&type=style&index=0&id=6f8e0d8b&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8e0d8b"]])

export default __exports__